"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../../utils/");
var classnames_1 = __importDefault(require("classnames"));
var get_1 = __importDefault(require("lodash/get"));
/**
 * Allow users to set margin all at once or individual margins.
 * @param margin
 * @param marginTop
 * @param marginBottom
 * @param marginLeft
 * @param marginRight
 * @return {*}
 */
var setMargin = function (margin, marginTop, marginBottom, marginLeft, marginRight) {
    if (margin) {
        return margin;
    }
    var margins = '';
    margins += marginTop ? marginTop + " " : '0 ';
    margins += marginRight ? marginRight + " " : '0 ';
    margins += marginBottom ? marginBottom + " " : '0 ';
    margins += marginLeft ? marginLeft : '0';
    return margins;
};
/**
 * Eventually want to add styled-system.
 */
var Div = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  background-image: ", ";\n  border-color: ", ";\n  border-style: ", ";\n  border-radius: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  border-width: ", ";\n  bottom: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  display: ", ";\n  font-family: \"Lato\", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  height: ", ";\n  left: ", ";\n  line-height: ", ";\n  margin: ", ";\n  min-height: ", ";\n  opacity: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: ", ";\n  padding:  ", ";\n  pointer-events: ", ";\n  position:  ", ";\n  right: ", ";\n  text-align: ", ";\n  top: ", ";\n  width: ", ";\n  z-index: ", "\n"], ["\n  background: ",
    ";\n  background-image: ", ";\n  border-color: ",
    ";\n  border-style: ", ";\n  border-radius: ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  ",
    ";\n  border-width: ", ";\n  bottom: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  display: ", ";\n  font-family: \"Lato\", sans-serif;\n  font-size: ", ";\n  font-weight: ", ";\n  height: ", ";\n  left: ", ";\n  line-height: ", ";\n  margin: ",
    ";\n  min-height: ", ";\n  opacity: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: ", ";\n  padding:  ", ";\n  pointer-events: ", ";\n  position:  ", ";\n  right: ", ";\n  text-align: ", ";\n  top: ", ";\n  width: ", ";\n  z-index: ", "\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor, theme = _a.theme;
    return utils_1.parseThemePath(backgroundColor, theme, 'inherit');
}, function (_a) {
    var backgroundImage = _a.backgroundImage;
    return backgroundImage ? "url(" + backgroundImage + ")" : 'none';
}, function (_a) {
    var border = _a.border, borderColor = _a.borderColor, theme = _a.theme;
    return (border && borderColor) ?
        utils_1.parseThemePath(borderColor, theme, '#eeeeee') : '#eeeeee';
}, function (_a) {
    var border = _a.border;
    return border ? 'solid' : 'none';
}, function (_a) {
    var borderRadius = _a.borderRadius, theme = _a.theme;
    return utils_1.parseThemePath(borderRadius, theme, '0');
}, function (_a) {
    var borderRadiusBottomLeft = _a.borderRadiusBottomLeft, theme = _a.theme;
    return borderRadiusBottomLeft && "border-bottom-left-radius:\n    " + utils_1.parseThemePath(borderRadiusBottomLeft, theme, 'unset');
}, function (_a) {
    var borderRadiusTopLeft = _a.borderRadiusTopLeft, theme = _a.theme;
    return borderRadiusTopLeft && "border-top-left-radius:\n    " + utils_1.parseThemePath(borderRadiusTopLeft, theme, 'unset');
}, function (_a) {
    var borderRadiusBottomRight = _a.borderRadiusBottomRight, theme = _a.theme;
    return borderRadiusBottomRight && "border-bottom-right-radius:\n    " + utils_1.parseThemePath(borderRadiusBottomRight, theme, 'unset');
}, function (_a) {
    var borderRadiusTopRight = _a.borderRadiusTopRight, theme = _a.theme;
    return borderRadiusTopRight && "border-top-right-radius:\n    " + utils_1.parseThemePath(borderRadiusTopRight, theme, 'unset');
}, function (_a) {
    var borderWidth = _a.borderWidth, border = _a.border;
    return border ? (borderWidth ? borderWidth : '1px') : '0';
}, function (_a) {
    var bottom = _a.bottom;
    return bottom;
}, function (_a) {
    var boxShadow = _a.boxShadow, theme = _a.theme;
    return get_1.default(theme, boxShadow, 'none');
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return utils_1.parseThemePath(color, theme, 'inherit');
}, function (_a) {
    var inline = _a.inline;
    return (inline ? 'inline-block' : 'block');
}, function (_a) {
    var fontSize = _a.fontSize, theme = _a.theme;
    return utils_1.parseThemePath(fontSize, theme, '20px');
}, function (_a) {
    var fontWeight = _a.fontWeight, theme = _a.theme;
    return utils_1.parseThemePath(fontWeight, theme, '400');
}, function (_a) {
    var height = _a.height;
    return height ? height : 'auto';
}, function (_a) {
    var left = _a.left;
    return left;
}, function (_a) {
    var lineHeight = _a.lineHeight;
    return lineHeight ? lineHeight : 'inherit';
}, function (_a) {
    var margin = _a.margin, marginTop = _a.marginTop, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft, marginRight = _a.marginRight;
    return setMargin(margin, marginTop, marginBottom, marginLeft, marginRight);
}, function (_a) {
    var minHeight = _a.minHeight;
    return minHeight ? minHeight : '0';
}, function (_a) {
    var opacity = _a.opacity;
    return opacity;
}, function (_a) {
    var paddingBottom = _a.paddingBottom;
    return paddingBottom;
}, function (_a) {
    var paddingLeft = _a.paddingLeft;
    return paddingLeft;
}, function (_a) {
    var paddingRight = _a.paddingRight;
    return paddingRight;
}, function (_a) {
    var paddingTop = _a.paddingTop;
    return paddingTop;
}, function (_a) {
    var padding = _a.padding, padded = _a.padded;
    return padded ? '20px' : (padding ? padding : null);
}, function (_a) {
    var pointerEvents = _a.pointerEvents;
    return pointerEvents;
}, function (_a) {
    var position = _a.position;
    return position ? position : 'initial';
}, function (_a) {
    var right = _a.right;
    return right;
}, function (_a) {
    var textAlign = _a.textAlign;
    return textAlign ? textAlign : 'inherit';
}, function (_a) {
    var top = _a.top;
    return top;
}, function (_a) {
    var width = _a.width;
    return (width ? width : 'auto');
}, function (_a) {
    var zIndex = _a.zIndex;
    return zIndex ? zIndex : 'auto';
});
var AXSBlock = function (_a) {
    var props = __rest(_a, []);
    return (React.createElement(Div, __assign({}, props, { backgroundColor: props.backgroundColor, borderRadius: props.borderRadius, borderWidth: props.borderWidth, className: classnames_1.default(['c-axs-block', props.className]) })));
};
AXSBlock.defaultProps = {
    backgroundColor: 'transparent',
    bottom: 'auto',
    color: 'inherit',
    fontSize: 'inherit',
    left: 'auto',
    right: 'auto',
    top: 'auto',
};
exports.default = AXSBlock;
var templateObject_1;
//# sourceMappingURL=AXSBlock.js.map